import React from "react";
import { useNavigate } from 'react-router-dom';
import "./index.scss";

import AppTool from "@/apps/@utils/app-tool";

const FooterComponent = () => {
  const navigate = useNavigate()

  return (
    <div className="cFooterComponent" >
      <div className="cMediaBox">
        <img className="cBg" src={window.assetUrl('/images/footer/media-box.jpg')} />
        <img className="cPhoneBg" src={window.assetUrl('/images/footer/phone-media-box.jpg')} />
        <img className="cLogo" src={window.assetUrl('/images/footer/white-logo.png')} />
        <div className="cMedia">
          <img className="cMediaItem" src={window.assetUrl('/images/footer/app-store.png')} onClick={() => { window.open("https://apps.apple.com/tw/app/%E9%AD%94%E6%B3%95%E4%BD%BF%E7%9A%84%E7%B4%84%E5%AE%9A/id6479690741") }} />
          <img className="cMediaItem" src={window.assetUrl('/images/footer/google-play.png')} onClick={() => { window.open("https://play.google.com/store/apps/details?id=com.isweety.mht") }} />
          <img className="cMediaItem" src={window.assetUrl('/images/footer/my-card.png')} onClick={() => { window.open("https://mht-data.isweetygirl.com/release/mht_115005_topupapp_product.apk") }} />
          <img className="cMediaItem" src={window.assetUrl('/images/footer/qoo-app.png')} onClick={() => { window.open("https://apps.qoo-app.com/app/71385") }} />
        </div>
        <img className="cGameName" src={window.assetUrl('/images/footer/name.png')} />
        <img className="cPhoneGameName" src={window.assetUrl('/images/footer/phone-name.png')} />
      </div>
      <div className="c15PlusBox">
        <img className="cBg" src={window.assetUrl('/images/footer/15-plus.jpg')} />
        <img className="cPhoneBg" src={window.assetUrl('/images/footer/phone-15-plus.jpg')} />
        <div className="cColyButton" onClick={() => { window.open("https://colyinc.com") }}/>
        <div className="cIsweetyButton" onClick={() => { window.open("https://www.isweety.com.tw") }}/>
        <div className="cPrivacyButton" onClick={() => { window.open(`${ process.env.REACT_APP_URL}/privacy`) }}/>
        <div className="cUserButton" onClick={() => {window.open(`${ process.env.REACT_APP_URL}/user`) }}/>
      </div>
      <div className="cPaddingBox" />
    </div>
  );
}

export default FooterComponent;